import { Card, Checkbox, Grid, Stack, ValidationErrors, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import {
  ContributorMatchBulkUpdate,
  ContributorMatchBulkUpdateResource,
  ContributorMatchBulkUpdateSchema,
} from "generated/openApi";
import { MatchFiles } from "./MatchFiles";

export const MatchUpdateSchema = (props: {
  updateSchema: ContributorMatchBulkUpdateSchema;
  setUpdateSchema: (value: ContributorMatchBulkUpdateSchema) => void;
  resource: ContributorMatchBulkUpdateResource;
  validationErrors: ValidationErrors | string[];
}) => {
  const { breakpointsRef, largeFieldBreakpoints } = useElementBreakpoints();
  const properties =
    props.resource.properties?.find((x) => x.propertyName === pn<ContributorMatchBulkUpdate>("updateSchema"))
      ?.children || [];

  const serviceField = () => {
    const propertyName = pn<ContributorMatchBulkUpdateSchema>("serviceId");
    const property = properties.find((x) => x.propertyName === propertyName);
    const isUpdating = props.updateSchema.updateServiceId;

    return (
      <Stack direction="row" alignItems="center" spacing="sm">
        <Checkbox
          checked={isUpdating}
          onChange={(e) => props.setUpdateSchema({ ...props.updateSchema, updateServiceId: e.target.checked })}
        />

        <Select
          modelProperty={property}
          errors={props.validationErrors[propertyName]}
          value={props.resource.services?.find((x) => x.id === props.updateSchema.serviceId)}
          options={props.resource.services}
          getOptionLabel={(option) => option.name}
          onChange={(e, value) => props.setUpdateSchema({ ...props.updateSchema, serviceId: value?.id })}
          disabled={!isUpdating}
        />
      </Stack>
    );
  };

  return (
    <Card header="Updating Fields">
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={largeFieldBreakpoints}>
          {serviceField()}
        </Grid>

        <Grid item xs={12}>
          <MatchFiles
            files={props.updateSchema.creatingFiles || []}
            setFiles={(files) => props.setUpdateSchema({ ...props.updateSchema, creatingFiles: files })}
          />
        </Grid>
      </Grid>
    </Card>
  );
};
